import { CashOutModalSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/CashOutModal/styles/CashOutModal.styles';

export const cashOutModalStyles: CashOutModalSchema = {
  modalContent: {
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    borderRadius: 'lg',
    fontFamily: 'accent',
    boxShadow:
      '0px 2px 5px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.16) inset',
    sx: {
      '.chakra-modal__close-btn': {
        color: 'white',
      },
    },
  },
  stackWrapper: {
    bg: 'blackAlpha.500',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
  },
  heading: { color: 'white' },
  moneyValues: { color: 'alpha.300', textTransform: 'uppercase' },
  cashedOutText: {},
  cashedOutQuestion: { color: 'white' },
  declineButton: {
    variant: 'outline',
    lineHeight: 'normal',
    sx: {
      borderImageSlice: 16,
      borderImageWidth: '19px',
      _hover: {
        borderImageSlice: 16,
        borderImageWidth: '19px',
        bg: 'whiteAlpha.200',
      },
    },
  },
  acceptButton: {
    lineHeight: 'normal',
  },
  doneButton: {},
};
